module.exports = __webpack_public_path__ + "static/roscokalis-753de915fd6c66dd2f03db306015eae2.jpg";